import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ClientService } from 'src/app/private/services/client.service';
import { UploadService } from 'src/app/private/services/upload.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-update-organization',
  imports: [SharedModule],
  templateUrl: './update-organization.component.html',
  styleUrl: './update-organization.component.scss'
})
export class UpdateOrganizationComponent {
  @Input() clientId = '';
  orgForm!: FormGroup;
  isInitialLoading = true;
  isUpdating = false;
  imageUrl: string | null = null;



  newMailhubUser: string = '';
  mailhubError: string = '';
  statusOptions = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
  ];

  leadChannelOptions = [
    { label: 'Tina', value: 'tina' },
    { label: 'WhatsApp', value: 'whatsApp' },
    { label: 'Manual', value: 'maual' },
    { label: 'Chatbot', value: 'chatbot' },
    { label: 'Website', value: 'website' }
  ];

  basicFields = [
  { key: 'name', label: 'Client Name', required: true, type: 'text' },
  { key: 'email', label: 'Email', required: true, type: 'email' },
  { key: 'contact', label: 'Contact Number', required: false, type: 'text' },
  { key: 'license_no', label: 'License No', required: false, type: 'text' },
  { key: 'specialty', label: 'Specialty', required: false, type: 'text' },
  { key: 'address', label: 'Address', required: false, type: 'text' },
  { key: 'bot_client_id', label: 'Bot Client ID', required: false, type: 'text' },
  
];
BILLING_STATES:any = [
  { name: 'Andhra Pradesh', code: '37', short: 'AP' },
  { name: 'Arunachal Pradesh', code: '12', short: 'AR' },
  { name: 'Assam', code: '18', short: 'AS' },
  { name: 'Bihar', code: '10', short: 'BR' },
  { name: 'Chhattisgarh', code: '22', short: 'CG' },
  { name: 'Goa', code: '30', short: 'GA' },
  { name: 'Gujarat', code: '24', short: 'GJ' },
  { name: 'Haryana', code: '06', short: 'HR' },
  { name: 'Himachal Pradesh', code: '02', short: 'HP' },
  { name: 'Jharkhand', code: '20', short: 'JH' },
  { name: 'Karnataka', code: '29', short: 'KA' },
  { name: 'Kerala', code: '32', short: 'KL' },
  { name: 'Madhya Pradesh', code: '23', short: 'MP' },
  { name: 'Maharashtra', code: '27', short: 'MH' },
  { name: 'Manipur', code: '14', short: 'MN' },
  { name: 'Meghalaya', code: '17', short: 'ML' },
  { name: 'Mizoram', code: '15', short: 'MZ' },
  { name: 'Nagaland', code: '13', short: 'NL' },
  { name: 'Odisha', code: '21', short: 'OD' },
  { name: 'Punjab', code: '03', short: 'PB' },
  { name: 'Rajasthan', code: '08', short: 'RJ' },
  { name: 'Sikkim', code: '11', short: 'SK' },
  { name: 'Tamil Nadu', code: '33', short: 'TN' },
  { name: 'Telangana', code: '36', short: 'TS' },
  { name: 'Tripura', code: '16', short: 'TR' },
  { name: 'Uttar Pradesh', code: '09', short: 'UP' },
  { name: 'Uttarakhand', code: '05', short: 'UK' },
  { name: 'West Bengal', code: '19', short: 'WB' },

  /* -------- UNION TERRITORIES -------- */

  { name: 'Andaman and Nicobar Islands', code: '35', short: 'AN' },
  { name: 'Chandigarh', code: '04', short: 'CH' },
  { name: 'Dadra and Nagar Haveli and Daman and Diu', code: '26', short: 'DN' },
  { name: 'Delhi', code: '07', short: 'DL' },
  { name: 'Jammu and Kashmir', code: '01', short: 'JK' },
  { name: 'Ladakh', code: '38', short: 'LA' },
  { name: 'Lakshadweep', code: '31', short: 'LD' },
  { name: 'Puducherry', code: '34', short: 'PY' }
];
billingFields:any = [
     { key: 'is_gst_registered', label: 'GST Registered', type: 'checkbox' },
    { key: 'gstin', label: 'GSTIN', type: 'text' },
    { key: 'billing_name', label: 'Billing Name', type: 'text' },
    { key: 'billing_email', label: 'Billing Email', type: 'email' },
    { key: 'billing_phone', label: 'Billing Phone', type: 'text' },

    { key: 'billing_address_line1', label: 'Address Line 1', type: 'text' },
    { key: 'billing_address_line2', label: 'Address Line 2', type: 'text' },
    { key: 'billing_city', label: 'City', type: 'text' },
    { key: 'billing_state', label: 'State', type: 'select' , data :this.BILLING_STATES },
    { key: 'gst_state_code', label: 'GST State Code', type: 'text', readonly:true },
    { key: 'billing_pincode', label: 'Pincode', type: 'text' },

    { key: 'billing_country', label: 'Country', type: 'text', readonly: true },

    // { key: 'reverse_charge', label: 'Reverse Charge', type: 'checkbox' },
    // { key: 'tax_exempt', label: 'Tax Exempt', type: 'checkbox' }
  ];
  featureModuleOptions = [
    { label: 'Dashboard', value: 'dashboard' },
    { label: 'Lead', value: 'lead' },
    { label: 'Event', value: 'event' },
    { label: 'Campaign', value: 'campaign' },
    { label: 'Setting', value: 'setting' },
    { label: 'Email Setting', value: 'email_setting' },
    { label: 'WhatsApp Template', value: 'whatsapp_template' },
    { label: 'Email Template', value: 'email_template' },
    { label: 'Contact Group', value: 'contact_group' },
    { label: 'User Setting', value: 'user_setting' },
    { label: 'User Log', value: 'user_log' },
    { label: 'Schedule Setting', value: 'schedule_setting' },
    { label: 'Leads Field Setting', value: 'leads_field_setting' },
    { label: 'Sales Mail Hub', value: 'sales-mail-hub' },
    { label: 'Tickets', value: 'tickets' },
    { label: 'Account', value: 'account' },
    { label: 'Contacts', value: 'contacts' },
    { label: 'Deals', value: 'deals' },
    { label: 'Report', value: 'report' },
    { label: 'Forecast', value: 'forecast' },
    { label: 'WooCommerce', value: 'woocommerce' }
  ];


  ngOnInit() {
    this.initForm();
    this.loadData(); // Simulate API call
  }

  constructor(private fb: FormBuilder,
    private api: ClientService,
    private messageService: MessageService,
    private uploadService: UploadService
  ) { }

  initForm() {
    this.orgForm = this.fb.group({

  /* ---------------- CORE CLIENT ---------------- */

  client_id: [this.clientId, Validators.required],
  name: ['', Validators.required],
  bot_client_id: [''],
  description: [''],
  logo: [''],
  license_no: [''],
  email: ['', [Validators.required, Validators.email]],
  contact: [''],
  specialty: [''],
  district_id: [''],

  leadChannels: this.fb.array([]),
  mailhub_users: this.fb.array([]),

  dateFormat: [''],

  feature_modules: this.fb.array(
    this.featureModuleOptions.map(option =>
      this.fb.control(option.value)
    )
  ),

  woocomerce_cred: this.fb.group({
    pdf_url: [''],
    base_url: [''],
    consumer_key: [''],
    consumer_secret: [''],
    PDF_INVOICE_ACCESS_KEY: ['']
  }),

  other_settings: this.fb.group({
    currency: ['']
  }),

  state_id: [''],
  city_id: [''],
  country_id: [''],
  address: [''],

  status: ['', Validators.required],
  isCron: [''],
  is_center: [''],
  get_location: [false],
  is_fixed_col: [false],
  is_user_wise_lead_space: [false],

  /* ---------------- GST & BILLING (NEW) ---------------- */

  gstin: [
    '',
    [
      Validators.minLength(15),
      Validators.maxLength(15),
      Validators.pattern(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
      )
    ]
  ],

  gst_state_code: [''], // auto-filled from GSTIN

  is_gst_registered: [false],

  billing_name: [''],
  billing_email: ['', Validators.email],
  billing_phone: [''],

  billing_address_line1: [''],
  billing_address_line2: [''],
  billing_city: [''],
  billing_state: [''],
  billing_pincode: [
    '',
    [Validators.pattern(/^[0-9]{6}$/)]
  ],
  billing_country: ['India'],

  reverse_charge: [false],
  tax_exempt: [false],
  billing_updated_at: ['']

});
  }

  loadData() {
    // Simulated API payload
    // const payload = {
    //   client_id: "4",
    //   name: "Gravitas AI",
    //   bot_client_id: null,
    //   description: null,
    //   logo: null,
    //   license_no: null,
    //   email: "info@gravitas.ai",
    //   contact: null,
    //   specialty: null,
    //   district_id: null,
    //   leadChannels: ["tina", "whatsApp", "maual"],
    //   mailhub_users: ["gaurav.rathore@gravitas.ai", "sonalika@gravitas.ai"],
    //   dateFormat: "DD-MM-YYYY",
    //   feature_modules: ["dashboard", "lead", "event", "campaign", "setting", "email_setting", "whatsapp_template", "email_template", "contact_group", "user_setting", "user_log", "schedule_setting", "leads_field_setting", "sales-mail-hub", "tickets", "account", "contacts", "deals", "report", "forecast", "woocommerce"],
    //   woocomerce_cred: {
    //     pdf_url: "https://rkeon-store.innovategrav.com/",
    //     base_url: "https://rkeon-store.innovategrav.com/wp-json/wc/v3",
    //     consumer_key: "ck_79811291f28dc0eb75021ff3ad3fe2733fe7de22",
    //     consumer_secret: "cs_ec65e11592632e8d040a1549f2504a8ca823cffc",
    //     PDF_INVOICE_ACCESS_KEY: "82ab911789"
    //   },
    //   other_settings: { currency: "INR" },
    //   state_id: null,
    //   city_id: null,
    //   country_id: null,
    //   address: null,
    //   status: "active",
    //   isCron: "True",
    //   is_center: null,
    //   get_location: true,
    //   is_fixed_col: true,
    //   is_user_wise_lead_space: true
    // };

    const body = {
      client_id: this.clientId
    }

    this.api.getClient(body).subscribe({
      next: (res: any) => {
        let payload = res;
        this.orgForm.patchValue(payload);

        // Set arrays
        this.setFormArray('leadChannels', payload.leadChannels);
        this.setFormArray('mailhub_users', payload.mailhub_users);
        this.setFormArray('feature_modules', payload.feature_modules);

        // set boolead isCron
        const isCronValue = payload.isCron === 'True' || payload.isCron === true;
        this.orgForm.get('isCron')?.setValue(isCronValue);

        // set boolead is_center
        const isCenterValue = payload.is_center === 'True' || payload.is_center === true;
        this.orgForm.get('is_center')?.setValue(isCenterValue);



        this.isInitialLoading = false;
      },
      error: (err) => {
        console.error('Error fetching organization data:', err);
        this.isInitialLoading = false;
      }
    });
  }

  setFormArray(key: string, values: string[]) {

    if (!this.orgForm.get(key)) {
      console.error(`Form control ${key} does not exist.`);
      return;
    }

    if (!Array.isArray(values)) {
      console.error(`Values for ${key} should be an array.`);
      return;
    }

    const formArray = this.orgForm.get(key) as FormArray;
    formArray.clear();
    values.forEach(val => formArray.push(this.fb.control(val)));
  }

  async handleFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
        this.orgForm.get('logo')?.setValue(file.name); // Optional: store file name
      };
      reader.readAsDataURL(file);

      const presignedUrl = await this.uploadToS3(file);

      // update the form with the presigned URL
      this.orgForm.get('logo')?.setValue(presignedUrl);

    }
  }

    async uploadToS3(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const folder = `crm/leads/attachments`;

      formData.append('file', file);
      formData.append('folders', folder);
      formData.append('bucket', 'global-upload-storage');

      this.uploadService.uploadDcouments(formData).subscribe({
        next: (response: any) => {
          resolve(response.url); // assuming response returns the uploaded file URL
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }
 onBillingStateChange(event: any) {
  const selectedCode = event.value; // e.g. '27'
  const state = this.BILLING_STATES.find((s:any) => s.code === selectedCode);

  if (!state) return;

  this.orgForm.patchValue({
    gst_state_code: state.code,
  });
}
  updateOrgDetails() {
    if (this.orgForm.invalid) {
      this.orgForm.markAllAsTouched();
      return;
    }
    this.isUpdating = true;
    
    const payload = {
      ...this.orgForm.value,
      isCron: this.orgForm.get('isCron')?.value ? 'True' : 'False',
      is_center: this.orgForm.get('is_center')?.value ? 'True' : 'False',
    }

    this.api.updateClient(payload).subscribe({
      next: (res: any) => {
          this.isUpdating = false;
      
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Organization updated successfully!'
          });
      },
      error: (err) => {
        console.error('Error updating organization:', err);
        this.isUpdating = false;
      }
    });

   
  }

  toggleLeadChannel(value: string,event: any) {
    const control = this.orgForm.get('leadChannels') as FormArray;
    if (event.target.checked) {
      control.push(this.fb.control(value));
    } else {
      const index = control.controls.findIndex((c:any) => c.value === value);
      if (index !== -1) {
        control.removeAt(index);
      }
    }
  }

  isChannelChecked(value: string): boolean {
    return this.orgForm.get('leadChannels')?.value.includes(value);
  }



  addMailhubUser() {
    const email = this.newMailhubUser?.trim();

    if (!email) {
      this.mailhubError = 'Email cannot be empty.';
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      this.mailhubError = 'Invalid email format.';
      return;
    }

    const control = this.orgForm.get('mailhub_users') as FormArray;
    if (control.value.includes(email)) {
      this.mailhubError = 'Email already added.';
      return;
    }

    control.push(this.fb.control(email));
    this.newMailhubUser = '';
    this.mailhubError = '';
  }

  removeMailhubUser(index: number) {
    const control = this.orgForm.get('mailhub_users') as FormArray;
    control.removeAt(index);
  }

  toggleFeatureModule(value: string, event: any) {
    const control = this.orgForm.get('feature_modules') as FormArray;
    if (event.target.checked) {
      control.push(this.fb.control(value));
    } else {
      const index = control.controls.findIndex((c:any) => c.value === value);
      if (index !== -1) {
        control.removeAt(index);
      }
    }
  }

  isFeatureChecked(value: string): boolean {
    return this.orgForm.get('feature_modules')?.value.includes(value);
  }

}

